export default {
	save: "Save",
	cancel: "Cancel",
	ok: "OK",
	change: "Change",
};
